import { render, staticRenderFns } from "./TaskUpdateIndividual.vue?vue&type=template&id=02f8fda4"
import script from "./TaskUpdateIndividual.vue?vue&type=script&lang=ts"
export * from "./TaskUpdateIndividual.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports